export const environment = {
  production: true,
  apiUrl: 'https://hom-apinucon.amc.fortaleza.ce.gov.br',
  envName: 'homolog',
  googleMapsApiKey: 'AIzaSyDwAyNOXOcgjYWpgakT4GbdbGnu138kq-U'
};

